"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = require("react");

var _useRootClose = _interopRequireDefault(require("react-overlays/useRootClose"));

var RootClose = function RootClose(_ref) {
  var children = _ref.children,
      onRootClose = _ref.onRootClose,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["children", "onRootClose"]);

  var _useState = (0, _react.useState)(null),
      rootElement = _useState[0],
      attachRef = _useState[1];

  (0, _useRootClose["default"])(rootElement, onRootClose, props);
  return children(attachRef);
};

var _default = RootClose;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/components/RootClose.react.js
// module id = 274
// module chunks = 0